import { useEffect } from "react";

import styles from "../../../../styles/mensageria.module.scss";
import { Button } from "../../../components/Button";
import { If } from "../../../components/control-statements";

const headerTypes = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
};

export const TemplatePreview = ({ setup, template, nextStep, loading }) => {
  const buttons = (template?.structure?.buttons || []).filter(
    (button) => button?.active === true
  );

  useEffect(() => {
    if (setup?.header) {
      const preview = document.getElementById("imagePreview");

      if (
        preview &&
        template?.structure?.header?.format === headerTypes.IMAGE
      ) {
        preview.setAttribute("src", template?.structure?.header?.example);
      }
    }
  }, [template]);

  const replaceGaps = (template, replaces) => {
    const message = template || "";
    const tagPairs = [
      {
        from: /\*(.*?)\*/gi,
        to: `<strong>$1</strong>`,
      },
      {
        from: /\{\{1\}\}/gi,
        to: `<span style="color:#6161ff">${replaces[0]}</span>`,
      },
      {
        from: /\{\{2\}\}/gi,
        to: `<span style="color:#6161ff">${replaces[1] || replaces[0]}</span>`,
      },
    ];

    return tagPairs?.reduce(
      (str, tag) => str?.replace(tag.from, tag.to),
      String(message)
    );
  };

  return (
    <div className={styles.scrollContainer}>
      <div className={styles.previewTemplate}>
        <If cond={setup?.header}>
          <div className={styles.templateHeader}>
            {template?.structure?.header?.format === headerTypes.TEXT && (
              <p>{template?.structure?.header?.text}</p>
            )}
            {template?.structure?.header?.format === headerTypes.IMAGE && (
              <img id="imagePreview" />
            )}
            {template?.structure?.header?.format === headerTypes.VIDEO && <></>}
          </div>
        </If>
        <div
          className={styles.templateBody}
          dangerouslySetInnerHTML={{
            __html:
              replaceGaps(
                template?.structure?.body?.text,
                template?.structure?.body?.examples
              ) || ``,
          }}
        ></div>
        <If cond={setup?.footer}>
          <div className={styles.templateFooter}>
            {template?.structure?.footer?.text}
          </div>
        </If>
        <If cond={buttons.length > 0}>
          <div className={styles.buttons}>
            {buttons.map((button) => (
              <div className={styles.button}>{button.text}</div>
            ))}
          </div>
        </If>
      </div>

      <div className={styles.footer}>
        <Button
          text="Concluir configuração do template"
          className="w-100"
          design="primary"
          loading={loading}
          onClick={nextStep}
        />
      </div>
    </div>
  );
};
